var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H3C1.34 0 0 1.34 0 3V19C0 20.66 1.34 22 3 22H11C12.66 22 14 20.66 14 19V3C14 1.34 12.66 0 11 0ZM8.5 20H5.5C5.22 20 5 19.78 5 19.5C5 19.22 5.22 19 5.5 19H8.5C8.78 19 9 19.22 9 19.5C9 19.78 8.78 20 8.5 20ZM12 17H2V3H12V17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDevice);
export default __webpack_public_path__ + "static/media/my_device.71fb4a0fdfd7ee2c6deaa1bb9f380432.svg";
export { ForwardRef as ReactComponent };